import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { apiClient } from '@services/api';
import BreadCrumbs from '@components/Breadcrumbs';
import Button from '@components/Button';
import Table from '@components/Table';
import NumberFormat from 'react-number-format';
import { format, isValid } from 'date-fns';
import ReactToPrint from 'react-to-print'
import { makeStyles } from '@material-ui/core'
import DatePicker from '@components/DatePicker';
import SelectSearch from 'react-select'
import TextField from '@components/TextField';
import Moment from 'react-moment';
import ChangeStateModal from './partials/ChangeStateModal';
import RefundModal from './partials/RefundModal';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import Select from '@components/Select';
import Alert from '@material-ui/lab/Alert';

const permissions = ['administrador'];

const useStyles = makeStyles((theme) => ({
  tabs: {
    marginTop: 15
  }
}))

const Index = (props) => {
  const componentRef = useRef()
  const [rows] = useState([]);

  const [dateProof, setDateProof] = useState(null);
  const [search, setSearch] = useState(null);
  const [saleId, setSaleId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [idSending, setIdSending] = useState('');
  const [status, setStatus] = useState(null);
  const [openModal, setOpenModal] = useState(false)
  const [selectedIdPayment, setSelectedIdPayment] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [integrations, setIntegrations] = useState([]);
  const [company, setCompany] = useState(null);
  const [companyNF, setCompanyNF] = useState(null);
  const [success, setSuccess] = useState(false);
  const [invoiceAlert, setInvoiceAlert] = useState(null); // { type: 'success'|'error', message: string }
  const [selectedModal, setSelectedModal] = useState(false); // saleId
  const [refundPayment, setRefundPayment] = useState(null); // linha p/ solicitar estorno
  const history = useHistory();
  const [selectedPayment, setSelectedPayment] = useState(null); // { id, amount }
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [refresh, setRefresh] = useState(false);

  const url = `cash_flow`;
  const classes = useStyles();

  useEffect(() => {
    //Oculta menu lateral
    props.setShowMenu(false)
    getIntegrations();
    getCompanies();
    getCompanyNF()
  }, []);

  const getCompanies = () => {
    apiClient.httpInstance.get(`/companies?pageSize=500`).then(response => {
      if (response.status === 200) {
        let companies = response.data.data.sort(function (a, b) {
          return a.surname < b.surname ? -1 : a.surname > b.surname ? 1 : 0;
        })
        setCompanies(companies);
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  const getIntegrations = () => {
    apiClient.httpInstance.get(`/companys_integrations`).then(response => {
      if (response.status === 200) {
        //let companies = response.data.data.sort(function (a, b) {
        //return a.surname < b.surname ? -1 : a.surname > b.surname ? 1 : 0;
        //})
        setIntegrations(response.data);
      }
    })
      .catch(error => {
        if (error) {
          console.log(error)
        }
      });
  }

  const sellerType = {
    seller: {
      text: 'Vendedor',
    },
    partner: {
      text: 'Vendedor parceiro',
    },
    agency: {
      text: 'Agência parceira',
    }
  }

  const breadcrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin/fluxo-de-caixa'
    },
  ];

  const getCompanyNF = () => {
    apiClient.httpInstance.get(`/get_company_nf/${company}`, {})
      .then(response => {
        if (response.status === 200) {
          setCompanyNF(response.data)
          setCompany(response.data)
        }
      })
      .catch((error) => console.log(error));
  }

  const updateCompanyNF = (id) => {
    setCompany(id)
    apiClient.httpInstance.post(`/change_company_nf/${id}`, {
      company_id: id
    }).then(response => {
      if (response.status === 200) {
        setCompanyNF(response.data)
        setSuccess(true)
        setTimeout(() => { setSuccess(false) }, 4000);
      }
    })
      .catch((error) => console.log(error));
  }

  const confirmPayment = () => {
    apiClient.httpInstance.put(`/confirm_sale_payment/${selectedIdPayment}`, {
      payment_id: selectedIdPayment
    }).then(response => {
      if (response.status === 200) {
        setOpenModal(false);
        setRefresh(true);
        setTimeout(() => setRefresh(false), 500);
      }
    })
      .catch((error) => console.log(error));
  }

  const invoiceGenerate = (saleId, idCompany) => {
    setSelectedModal(false)
    setIdSending(saleId)
    setLoading(true)
    apiClient.httpInstance.post(`/generate_invoice/${saleId}`, {
      company_id: idCompany ? idCompany : company,
      sale_payment_id: selectedPayment?.id,
    })
      .then(response => {
        if (response.status === 200) {
          setLoading(false)
          setIdSending('')
          setInvoiceAlert({ type: 'success', message: 'Nota fiscal gerada com sucesso!' })
          setTimeout(() => setInvoiceAlert(null), 5000)
          // Atualiza a tabela no lugar (preserva filtros) em vez de recarregar a página
          setRefresh(true)
          setTimeout(() => setRefresh(false), 600)
        }
      })
      .catch((error) => {
        const msg = error?.response?.data?.message || 'Erro ao gerar nota fiscal. Tente novamente.'
        setLoading(false)
        setInvoiceAlert({ type: 'error', message: msg })
        setTimeout(() => setInvoiceAlert(null), 8000)
      });
  }

  const changeDateProof = (date) => {
    setDateProof(isValid(date) === true ? format(date, "yyyy-MM-dd") : null)
  }

  const changePayment = (idPayment) => {
    setSelectedIdPayment(idPayment)
    setOpenModal(true)
  }

  const onOpen = (id, saleId, paymentId, paymentAmount) => {
    const item = document.getElementById(`meuItem${id}`);
    const posicao = item.getBoundingClientRect();
    setPosition({ x: posicao?.x, y: posicao?.bottom, bottom: posicao?.bottom });
    setSelectedModal(saleId);
    setSelectedPayment({ id: paymentId, amount: paymentAmount });
  }

  const tableParams = useMemo(() => ({
    'search': search,
    'date_proof': dateProof,
    'sale_id': saleId,
    'customer_id': customerId,
  }), [search, dateProof, saleId, customerId]);

  return <>
    <div className="px-7">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue mb-3">
        <div className="flex items-center">
          <Icon className="mr-2">
            monetization_on_icon
          </Icon>
          <span>Fluxo de Caixa</span>
        </div>
      </div>
      <div className="p-4 mt-4 bg-white border-1" style={{ borderRadius: '10px 10px 0px 0px' }}>
        <div className="flex flex-wrap items-center space-x-3">
          {((saleId !== '' && saleId !== null) || (customerId !== '' && customerId !== null)) && <div className="flex-none cursor-pointer">
            <Icon className="mr-2" onClick={() => {
              setSaleId('')
              setCustomerId('')
            }}>
              cached
            </Icon>
          </div>}
          <div className="flex-none">
            <TextField
              className="inputRounded"
              label="Busque por cliente, vendedor, referência, documento"
              width="450px"
              variant="outlined"
              type="text"
              name="search"
              onChange={(ev) => setSearch(ev.target.value)}
            />
          </div>
          <div className="flex-none">
            <DatePicker
              label="Data"
              value={dateProof !== null ? `${dateProof} 00:00:00` : null}
              onChange={date => changeDateProof(date)}
            />
          </div>
          <div className="flex-none sm:p-2 m-2 md:m-0 sm:w-40 min-w-max">
            <Select
              label="Emissora da NF"
              value={companyNF ? companyNF : ''}
              width="160px"
              withoutAll
              onChange={(e) => updateCompanyNF(e.target.value)}
              items={{
                field: {
                  value: 'id',
                  text: 'surname',
                  key: 'key'
                },
                data: companies
              }}
            ></Select>
          </div>
          {success && <Alert className="m-0 p-0 text-sm bg-white" severity="success" color="success">
            Empresa emissora atualizada com sucesso
          </Alert>}
        </div>
      </div>

      {/* Alert de resultado da emissão de nota */}
      {invoiceAlert && (
        <div style={{ position: 'fixed', top: 16, right: 16, zIndex: 99999, minWidth: 320 }}>
          <Alert severity={invoiceAlert.type} onClose={() => setInvoiceAlert(null)}>
            {invoiceAlert.message}
          </Alert>
        </div>
      )}

      {/* ModalChoose fora do DataGrid para evitar overflow:hidden das células */}
      {selectedModal && integrations.filter(i => i.name === 'enotas').length > 0 && (
        <div style={{ position: 'fixed', top: position.y, left: position.x, zIndex: 99999 }}>
          <ModalChoose
            integrations={integrations.filter(i => i.name === 'enotas')}
            onClose={() => setSelectedModal(false)}
            onChoose={(idCompany) => permissions.includes(props?.theme?.permission) ? invoiceGenerate(selectedModal, idCompany) : null}
          />
        </div>
      )}

      <Table
        path="/cash_flow"
        onRowClick={null}
        refresh={refresh}
        params={tableParams}
        columns={[
          {
            headerName: 'Referência',
            headerClassName: 'super-app-theme--header',
            field: 'references',
            flex: 1,
            renderCell: (params) => {
              const row = params.row;
              return (<div className="flex items-center" onClick={() => setSaleId(row.sale_id)}>
                {row.status === 'canceled' &&
                  <Icon className="mr-1 text-red-500">block</Icon>
                }
                {row?.total_payments > 1 &&
                  <Icon className="mr-1 items-center" style={{ fontSize: '12px', color: process.env.REACT_SECONDARY_PRIMARY_COLOR }} onClick={() => setSaleId(row.sale_id)}>circle</Icon>
                }
                <div className="flex flex-col" style={{ lineHeight: '16px' }}>
                  <span>{row.sale_references || row.references}</span>
                  {row.sale_references && row.references && row.sale_references !== row.references
                    ? <small style={{ color: '#8a9ab5', fontSize: '11px' }}>{row.references}</small>
                    : row.payment_source && (
                        <small style={{
                          color: row.payment_source === 'FTAPP' ? '#62DEC2' : row.payment_source === 'SITE' ? '#7b9cff' : row.payment_source === 'IMPORT' ? '#888' : '#f0a500',
                          fontSize: '10px',
                          fontWeight: 'bold',
                          letterSpacing: '0.5px'
                        }}>
                          {row.payment_source === 'FTAPP' ? '● APP' : row.payment_source === 'SITE' ? '● SITE' : row.payment_source === 'IMPORT' ? '● LEGADO' : '● ORC'}
                        </small>
                      )
                  }
                </div>
              </div>);
            }
          },
          {
            headerName: 'Vendedor',
            headerClassName: 'super-app-theme--header',
            field: 'seller_name',
            flex: 1,
          },
          {
            headerName: 'Cliente',
            headerClassName: 'super-app-theme--header',
            field: 'customer_name',
            flex: 1,
            renderCell: (params) => {
              const row = params.row;
              return (<div className="items-center" style={{ lineHeight: '25px' }} onClick={() => setCustomerId(row.customer_id)}>
                <span>{row.customer_name}</span>
                <small className="flex m-0" style={itemStyles}>{row.customer_sales} {row?.customer_sales > 1 ? 'vendas' : 'venda'}</small>
              </div>);
            }
          },
          {
            headerName: 'Documento',
            headerClassName: 'super-app-theme--header',
            field: 'document',
            flex: 1,
          },
          {
            headerName: 'Valor Pago',
            headerClassName: 'super-app-theme--header',
            field: 'customer_paid_value',
            width: 140,
            renderCell: (params) => {
              const row = params.row;
              return <NumberFormat
                value={Number(row.customer_paid_value) || 0}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span className="flex items-center">{value}</span>}
              />;
            }
          },
          {
            headerName: 'Data do pagamento',
            headerClassName: 'super-app-theme--header',
            field: 'created_at',
            flex: 1,
            renderCell: (params) => {
              const row = params.row;
              return row.created_at ? <Moment format="DD/MM/YYYY" date={row.created_at} /> : ''
            }
          },
          {
            headerName: 'Comprovante',
            headerClassName: 'super-app-theme--header',
            field: 'path',
            flex: 1,
            renderCell: (params) => {
              const row = params.row;
              const isAsaas = row.path && row.path.startsWith('http');
              const proofUrl = row.path
                ? (isAsaas ? row.path : `${process.env.REACT_APP_BASE_IMAGE_URL}/${row.path}`)
                : null;
              return <>
                {proofUrl ?
                  <a id={'comp_name_' + row.id} className="cursor-pointer flex items-center" href={proofUrl} target="_blank" style={{ textDecoration: 'underline' }}>
                    Visualizar
                    {isAsaas && <Icon style={{ fontSize: 14, marginLeft: 4 }}>open_in_new</Icon>}
                  </a>
                  :
                  'Não adicionado'
                }
              </>
            }
          },
          {
            headerName: 'Recebimento',
            headerClassName: 'super-app-theme--header',
            field: 'confirmed',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
              const row = params.row
              return <>
                {row.confirmed === false ?
                  permissions.includes(props?.theme?.permission) && <Button
                    textcolor="#fff"
                    margintop="0px"
                    color="primary"
                    size="small"
                    type="button"
                    variant="text"
                    className="cursor-pointer"
                    onClick={() => permissions.includes(props?.theme?.permission) ? changePayment(row.id) : null}
                  >
                    Confirmar
                  </Button>
                  :
                  <div className="flex flex-row items-center justify-center">
                    <Icon className="mr-2">check_circle</Icon>
                    {row.invoice_id && row.invoice_id !== null ?
                      <div className="flex flex-col">
                        <a
                          className="cursor-pointer m-0 p-0"
                          style={{ textDecoration: 'underline', maxHeight: 20, height: 20 }}
                          href={row.invoice_url || `https://app.enotas.com.br`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Nota Gerada
                        </a>
                        <span className='m-0 p-0' style={{ maxHeight: 45, height: 45, fontSize: 12 }}>{row.company_name}</span>
                      </div>

                      :
                      !loading ?
                        permissions.includes(props?.theme?.permission) ?
                          <a
                            id={`meuItem${row?.id}`}
                            className="cursor-pointer"
                            style={{ textDecoration: 'underline' }}
                            onClick={(e) => { if (selectedModal !== row.sale_id) { onOpen(row.id, row.sale_id, row.id, row.customer_paid_value) } else { setSelectedModal(false) } }}
                          >
                            Emitir nota
                          </a> :
                          'Pago'
                        :
                        row.sale_id === idSending ?
                          <div className="flex-1 mt-4">
                            <CircularProgress size={30} />
                          </div>
                          :
                          permissions.includes(props?.theme?.permission) &&
                          <a
                            id={`meuItem${row?.id}`}
                            className="cursor-pointer"
                            style={{ textDecoration: 'underline' }}
                            onClick={(e) => { if (selectedModal !== row.sale_id) { onOpen(row.id, row.sale_id, row.id, row.customer_paid_value) } else { setSelectedModal(false) } }}
                          >
                            Emitir nota
                          </a>
                    }
                  </div>
                }
              </>
            }
          },
          {
            headerName: 'Estorno',
            headerClassName: 'super-app-theme--header',
            field: 'estorno',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => {
              const row = params.row;
              // Backend decide via asaas_charge_id (string, sem ambiguidade de boolean
              // vindo do Postgres/PDO). Antes o front chutava pelo prefixo de row.references,
              // que é só um código interno (uniqid) — nunca foi o pay_id do Asaas na maioria
              // dos fluxos (conversão de orçamento, pagamento manual). Ver migration 2026_08_11.
              const refundavel = !!row.asaas_charge_id;
              if (!refundavel || !permissions.includes(props?.theme?.permission)) return '—';
              // Regra do Marcelo (2026-08-25, caso OR6A774C802A494): quando a venda tem
              // mais de 1 método de pagamento (ex: PIX + Cartão), sempre preferir estornar
              // pelo cartão. sale_distinct_payment_methods vem calculado do backend
              // (SaleController::cashFlow) contando métodos DISTINTOS da venda — não conta
              // como "múltiplo" uma venda com 2 pagamentos do mesmo método (entrada+saldo).
              const isCardPreferred = row.payment_method === 'card' && (row.sale_distinct_payment_methods || 0) > 1;
              return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                  <a className="cursor-pointer" style={{ textDecoration: 'underline', color: isCardPreferred ? '#5DCAA5' : '#0a7c5c' }}
                     onClick={() => setRefundPayment(row)}>
                    Solicitar
                  </a>
                  {isCardPreferred &&
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#0c3729', color: '#5DCAA5', fontSize: 11, padding: '2px 8px', borderRadius: 20 }}>
                      Preferir p/ estorno
                    </span>
                  }
                </div>
              );
            }
          },
        ]}
        rows={rows} />
    </div>
    <ChangeStateModal
      open={openModal}
      close={() => setOpenModal(false)}
      onCreate={confirmPayment}
      status={status}
      selectedIdPayment={selectedIdPayment}
      setStatus={setStatus}
    />
    <RefundModal
      open={!!refundPayment}
      payment={refundPayment}
      close={() => setRefundPayment(null)}
      onSubmitted={() => { setRefundPayment(null); history.push('/admin/reembolsos'); }}
    />
  </>
}

export default Index;

const COMPANY_COLORS = ['#62DEC2', '#F5A623'];

const ModalChoose = ({ integrations, onChoose, onClose }) => {
  return (
    <div
      style={{
        display: 'flex', flexDirection: 'column', width: '190px',
        backgroundColor: '#0f2744', border: '1px solid #1e3a5f',
        borderRadius: '10px', overflow: 'hidden', zIndex: 99999,
        boxShadow: '0 4px 20px rgba(0,0,0,0.4)'
      }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '6px 8px 0' }}>
        <Icon
          onClick={() => onClose()}
          style={{ cursor: 'pointer', fontSize: 16, color: '#8ba3c0' }}>close</Icon>
      </div>

      {integrations && integrations.map((company, index) => {
        const color = COMPANY_COLORS[index % COMPANY_COLORS.length];
        return (
          <div
            key={index}
            onClick={() => onChoose(company?.company_id)}
            style={{
              padding: '10px 16px', cursor: 'pointer', display: 'flex',
              alignItems: 'center', gap: 8,
              borderTop: index === 0 ? '1px solid #1e3a5f' : 'none',
              transition: 'background 0.15s'
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#162f52'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: color, flexShrink: 0 }} />
            <span style={{ color: '#e2eaf5', fontSize: 14, fontWeight: 500 }}>{company.titulo}</span>
          </div>
        )
      })}
    </div>
  )
}

const itemStyles = {
  justifyContent: 'space-between',
  borderRadius: '8px',
  padding: '2px 5px',
  textTransform: 'capitalize',
  fontWeight: 'bold',
  backgroundColor: '#D6FFF6',
  height: '15px',
  width: '75px',
  alignItems: 'center',
}